import { render, staticRenderFns } from "./newAddResource.vue?vue&type=template&id=16285734&scoped=true"
import script from "./newAddResource.vue?vue&type=script&lang=js"
export * from "./newAddResource.vue?vue&type=script&lang=js"
import style0 from "./newAddResource.vue?vue&type=style&index=0&id=16285734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16285734",
  null
  
)

export default component.exports